export class CycleDetectorVisitor {
  constructor() {
    this.visitedNodes = {}
    this.cycleDetected = false
  }

  allowTraversal({ nextNode }) {
    // if we've already visited this node, then we've hit a cycle
    if (this.visitedNodes[nextNode.field_id]) {
      this.cycleDetected = true
      return false
    }

    // indicate that it's okay to go to the next node
    return true
  }

  enterNode({ currentNode }) {
    this.visitedNodes[currentNode.field_id] = true
  }

  leaveNode({ currentNode }) {
    this.visitedNodes[currentNode.field_id] = false
  }

  getCycleDetected() {
    return this.cycleDetected
  }
}
